import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountingPeriodCloseResult } from '../../../accounting/model/opening-balance-run';
import { MultiselectCommand, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { companyCommand } from '../../command/company.command';
import { SetLockDateComponent } from '../../component/set-lock-date/set-lock-date.component';
import { Company } from '../../model/company';

@Injectable()
export class CompanyCloseAccountingPeriodCommandHandler implements ICommandHandler {
  constructor(
    private readonly _actionService: ActionWindowService,
    private readonly _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === companyCommand.closeAccountingPeriod && command.items.length > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      const companies = command.items as Company[];
      return this._actionService.open(SetLockDateComponent, this._injector, null, { companies, mode: 'close' }, true).pipe(
        map((result: AccountingPeriodCloseResult) => {
          result?.closedRuns?.forEach(run => {
            const company = companies.find(item => item.id === run.companyId);
            if (company) {
              company.accountingClosedTo = run.closedToDate;
            }
          });
        })
      );
    }
  }
}
